import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=8c8ee770&scoped=true&"
import script from "./Project.vue?vue&type=script&lang=js&"
export * from "./Project.vue?vue&type=script&lang=js&"
import style0 from "./Project.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Project.vue?vue&type=style&index=1&id=8c8ee770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8ee770",
  null
  
)

export default component.exports